import { render, staticRenderFns } from "./AddSceneStepOverview.vue?vue&type=template&id=48df863b"
import script from "./AddSceneStepOverview.vue?vue&type=script&lang=js"
export * from "./AddSceneStepOverview.vue?vue&type=script&lang=js"
import style0 from "./AddSceneStepOverview.vue?vue&type=style&index=0&id=48df863b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports